<app-banner [heading]="'OUR INFRA - CHEMISTRY LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->

	<section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 " >
            
              <img src="assets/img/infra/sciencelabs/chemistry-lab-2.jpg" class="img-fluid" alt="best school in kurukshetra">
            </div>
            
            <div class="col-lg-6  pt-5 pt-lg-0" >  
              <p> <br>The Chemistry Laboratory with all essential equipments &amp; resources are in place at 
			  Tagore Global School.<br><br>The experiments are being monitored in the presence of subject teacher.
			  <br><br>The safety &amp; security while conducting experiments under supervision are the common
			  practice here at TGS.
			  
			  </p>
              
            </div>
          </div>

		  
		</div>
      
	</section><!-- End About Section -->
	
	
	
    
    
  </main>